import { render, staticRenderFns } from "./FiltersSummary.vue?vue&type=template&id=3781e7e6&"
import script from "./FiltersSummary.vue?vue&type=script&lang=js&"
export * from "./FiltersSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports